import { queryBuilder } from '@lbs/swarm-client';
import { GameTypeEnum } from '@common/constants/enums/gameType';
import { commonSportTypes } from '@common/constants';


export const getSwarmSubscriptionRequestSecondPopularSports = (sectionType) => {
  const builder = queryBuilder()
    .useSource('betting')
    .selectSport(['id', 'name', 'alias', 'order'])
    .selectGame('@count')
    .whereSport('type')
    .in(commonSportTypes);

  if (sectionType === 'live') {
    builder.whereGame('type').is(GameTypeEnum.Live);
  } else {
    builder
      .orWhereGame('type').in([GameTypeEnum.Prematch, GameTypeEnum.FutureLive])
      .orWhereGame('visible_in_prematch').is(1);
  }

  return builder.getParams();
};
